import React from 'react'
import {MdViewCompact, MdPanoramaFishEye} from 'react-icons/md';
import {Button} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import firebaseHelper from "../../helpers/FirebaseHelper";

const propTypes = {};

class BusinessDataTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
        };
    }

    setMaster(e) {
        e.preventDefault();
        this.props.setMaster(this.state.user.id)
    }

    hide(e) {
        e.preventDefault();
        this.props.hide(this.state.user.id)
    }

    endTrial(e) {
        e.preventDefault();
        this.props.endTrial(this.state.user.id)
    }

    startTrial(e) {
        e.preventDefault();
        this.props.startTrial(this.state.user.id)
    }

    sendTrialExpiresEmail(e) {
        e.preventDefault();
        this.props.sendTrialExpiresEmail(this.state.user.id)
    }

    // send_news(e) {
    //     e.preventDefault();
    //     this.props.send_news(this.state.user.id)
    // }

    // send_news_082020(e) {
    //     e.preventDefault();
    //     this.props.send_news_082020(this.state.user.id)
    // }

    unpublish(e) {
        e.preventDefault();
        this.props.unpublish(this.state.user.id)
    }

    delete_student_photos(e) {
        this.state.user.students.forEach(student => {
            firebaseHelper.deleteStudentPhoto(student)
        })
    }

    deleteTeacherPhotos(e) {
        this.state.user.teachers.forEach(teacher => {
            firebaseHelper.deleteTeacherPhoto(teacher)
        })
    }

    make_client(e) {
        e.preventDefault();
        this.props.make_client(this.state.user.id)
    }

    render() {
        return (
            <tr>

                <td style={{wordBreak: "break-all"}}>
                    <span className="mb-0 text-sm">
                        <a href="#"
                           onClick={(e) => this.props.onUserIdSelected(e, this.state.user.id)}>{this.state.user.id}</a>
                        <span className="mb-0 text-sm">
                            { " " } {this.state.user.name}
                        </span>
                        {this.state.user.master_name &&
                        <span className="mb-0 text-sm text-pink">
                            { " " } {this.state.user.master_name}
                        </span>
                        }
                    </span>
                    <div className="mb-0 text-blue">
                        created: {dateHelpers.formatDate(new Date(this.state.user.created_at))}
                    </div>
                    <div className="mb-0 text-yellow">
                        updated: {dateHelpers.formatDate(new Date(this.state.user.updated_at))}
                    </div>
                    <div className="mb-0 text-success">
                        last login: {this.state.user.last_login ? dateHelpers.formatDate(new Date(this.state.user.last_login)) : "-"}
                    </div>

                    <div className="mb-0 text-success">
                        teachers with photo: {this.state.user.teachers?.length}
                    </div>
                    <div className="mb-0 text-success">
                        students with photo: {this.state.user.students?.length}
                    </div>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {this.state.user.pro || "?"}
                        <br/>
                        {this.state.user.trial_ends && this.state.user.trial_ends != this.state.user.pro &&
                            <div>
                                {this.state.user.trial_ends || "?"}
                            </div>
                        }
                    </span>
                </td>

                <td className="text-right align-content-end">
                    <Button className="btn-icon" color="danger"
                            onClick={e => this.endTrial(e)}
                            size="sm">
                        END TRIAL
                    </Button>

                    <Button className="btn-icon" color="success"
                            onClick={e => this.startTrial(e)}
                            size="sm">
                        START TRIAL
                    </Button>

                    <Button className="btn-icon" color="info"
                            onClick={e => this.sendTrialExpiresEmail(e)}
                            size="sm">
                        TRIAL EXP EMAIL
                    </Button>

                    <Button className="btn-icon" color="success"
                            onClick={e => this.setMaster(e)}
                            size="sm">
                        Master
                    </Button>

                    <Button className="btn-icon" color="danger"
                            onClick={e => this.hide(e)}
                            size="sm">
                        Hide
                    </Button>

                    <Button className="btn-icon" color="danger"
                            onClick={e => this.make_client(e)}
                            size="sm">
                        CLIENT
                    </Button>

                    {this.state.user.public === true &&
                    <Button className="btn-icon" color="danger"
                            onClick={e => this.unpublish(e)}
                            size="sm">
                        UNPUBLISH
                    </Button>
                    }
                    <Button className="btn-icon" color="danger"
                            onClick={e => this.deleteTeacherPhotos(e)}
                            size="sm">
                        DEL TEACHER PHO
                    </Button>

                    <Button className="btn-icon" color="danger"
                            onClick={e => this.delete_student_photos(e)}
                            size="sm">
                        DEL stud PHO
                    </Button>
                </td>
            </tr>
        )
    }
}

BusinessDataTableRow.propTypes = propTypes;

export default BusinessDataTableRow;